"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9246,4651],{

/***/ 99246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47322);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);




/** The oralB button */



var Button = function Button(_ref) {
  var children = _ref.children,
      Tag = _ref.tag,
      whiteTheme = _ref.whiteTheme,
      size = _ref.size,
      className = _ref.className,
      dataActionDetail = _ref.dataActionDetail,
      greyTheme = _ref.greyTheme,
      invertedTheme = _ref.invertedTheme,
      borderTheme = _ref.borderTheme,
      borderThemeBlue = _ref.borderThemeBlue,
      textTheme = _ref.textTheme,
      styles = _ref.styles,
      href = _ref.href,
      target = _ref.target,
      role = _ref.role,
      ariaLabel = _ref.ariaLabel,
      type = _ref.type,
      dataCustom = _ref.dataCustom,
      dataActionLabel = _ref.dataActionLabel,
      disabled = _ref.disabled,
      sku = _ref.sku,
      onClick = _ref.onClick,
      id = _ref.id,
      ariaDescribedBy = _ref.ariaDescribedBy,
      title = _ref.title;

  if (!children) {
    return null;
  }

  className = className ? "ob-button ".concat(className) : 'ob-button';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
    fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_2__["default"], {}),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Tag, {
      className: className,
      "data-action-detail": dataActionDetail,
      "data-size": size,
      "data-white-theme": whiteTheme,
      "data-action-label": dataActionLabel,
      "data-grey-theme": greyTheme,
      "data-inverted-theme": invertedTheme,
      "data-border-theme": borderTheme,
      "data-border-theme-blue": borderThemeBlue,
      "data-text-theme": textTheme,
      "data-custom": dataCustom,
      "data-sku": sku,
      type: Tag === 'button' && type ? type : undefined,
      href: ['a'].indexOf(Tag) > -1 && href ? href : undefined,
      target: ['a', 'form'].indexOf(Tag) > -1 ? target : undefined,
      formTarget: Tag === 'button' ? target : undefined,
      rel: target === '_blank' ? 'noopener noreferrer' : undefined,
      role: role,
      "aria-label": ariaLabel,
      style: styles,
      disabled: disabled,
      onClick: onClick,
      id: id,
      "aria-describedby": ariaDescribedBy,
      title: title,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
        dangerouslySetInnerHTML: {
          __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default().sanitize(children)
        }
      })
    })
  });
};

Button.defaultProps = {
  tag: 'button',
  styles: {}
};
/* harmony default export */ __webpack_exports__["default"] = (Button);

/***/ })

}]);